export default {
    title: 'Edit panel title',
    required: 'Please enter a title',
    label: 'Panel titel',
    submit: 'Save'
}
